export default __webpack_public_path__ + "5b6bb12f30efbff6b7f81c5c5fb40fee.png";